import React, { useCallback } from "react";
import styles from "./style.module.css";
import ImageComponent from "../ImageComponent";
import clsx from "clsx";
import { pwaBannerTypes } from "../../interfaces/TournamentsConfig";
import { NavLink } from "react-router-dom";
import { CLEVERTAP_EVENTS, NAVIGATION_ROUTES } from "../../constant";
import { getPageName} from "../../utils/helpers/common";
import { pushClevertapEvent } from "../../utils/analytics/clevertap";
import { OperatingSystem } from "../../utils/osDetector";
import { osDetector } from "../../utils/osDetector";
interface Window {
  clevertap?: {
    event: {
      push: (eventName: string, eventData: Record<string, unknown>) => void;
    };
  };
}

const IOS_APP_URL = "https://apps.apple.com/in/app/zupee-play-ludo-game-online/id1576310504";

const PromotionBanner: React.FC<pwaBannerTypes> = ({ imageUrl, bannerText, cta }) => {
  const { type = "", value = "/" } = cta || {};
  const bannerWinningText = bannerText || "";

  // Clevertap Event and redirect to app store if iOS
  const handleBannerClick = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    const currentOS = osDetector();
    const isIOS = currentOS === OperatingSystem.IOS;
    
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_CLICK_BANNER, {
      "location": getPageName(),
      "os": isIOS ? "iOS" : "Android"
    });

    if(isIOS) {
      event.preventDefault();
      window.open(IOS_APP_URL, "_blank");
    } else if (type === "EXTERNAL_LINK") {
      event.preventDefault();
      window.open(value, "_blank");
    }
  }, [type, value]);

  return (
    <NavLink
      to={value}
      target={type === "EXTERNAL_LINK" ? "_blank" : "_self"}
      state={{ url: value }}
      rel={type === "EXTERNAL_LINK" ? "noopener noreferrer" : undefined}
      className={clsx(styles.promotionBannerBox)}
      onClick={handleBannerClick}
    >
      {bannerWinningText && (
        <div className={clsx(styles.bannerWinningText, "fontColorSecondary fontWeight800")}>
          {bannerWinningText}
        </div>
      )}
      <ImageComponent
        src={imageUrl}
        alt="promotion banner"
        className={clsx(styles.promotionBanner)}
      />
    </NavLink>
  );
};

export default PromotionBanner;
